import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Pages
import HomePage from "./pages/HomePage";
import PatientPage from "./pages/PatientPage";
import CaregiverPage from "./pages/CaregiverPage";
import PatientStudiesPage from "./pages/PatientStudiesPage";
import CaregiverStudiesPage from "./pages/CaregiverStudiesPage";
import PatientSignUpPage from "./pages/PatientSignUpPage";
import CaregiverSignUpPage from "./pages/CaregiverSignUpPage";
import AccountRequestLinkPage from "./pages/AccountRequestLinkPage";
import AccountUpdatePage from "./pages/AccountUpdatePage";
import AccountUpdatedPage from "./pages/AccountUpdatedPage";
import AccountDeletedPage from "./pages/AccountDeletedPage";
import RegisterPage from "./pages/RegisterPage";
import AboutPage from "./pages/AboutPage";
import FAQPage from "./pages/FAQPage";
import ReviewsPage from "./pages/ReviewsPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminAcceptInvitePage from "./pages/AdminAcceptInvitePage";
import ReviewSubmitPage from "./pages/ReviewSubmitPage";
import ScreenerPage from "./pages/ScreenerPage";
import StudyDetailPage from "./pages/StudyDetailPage";
import ResearchConditionPage from "./pages/ResearchConditionPage";
import ResearchIndexPage from "./pages/ResearchIndexPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import CookiesPage from "./pages/CookiesPage";

// Components
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { CookieBanner } from "./components/CookieBanner";
import { PostHogLoader } from "./components/PostHogLoader";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <PostHogLoader />
      <CookieBanner />
      <div className="min-h-screen flex flex-col">
        <Toaster
          position="top-right"
          richColors
          toastOptions={{
            style: {
              borderRadius: "12px",
            },
          }}
        />
        <Routes>
          {/* Admin routes - no navbar/footer */}
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/accept-invite" element={<AdminAcceptInvitePage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />

          {/* Standalone screener - no navbar/footer */}
          <Route path="/screener/:study_id" element={<ScreenerPage />} />
          
          {/* Public routes with navbar/footer */}
          <Route
            path="*"
            element={
              <>
                <Navbar />
                <main className="flex-1">
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/patient" element={<PatientPage />} />
                    <Route path="/caregiver" element={<CaregiverPage />} />
                    <Route path="/patient/studies" element={<PatientStudiesPage />} />
                    <Route path="/caregiver/studies" element={<CaregiverStudiesPage />} />
                    <Route path="/studies/:study_id" element={<StudyDetailPage />} />
                    <Route path="/research" element={<ResearchIndexPage />} />
                    <Route path="/research/:slug" element={<ResearchConditionPage />} />
                    <Route path="/register" element={<RegisterPage />} />
                    <Route path="/patient/sign-up" element={<PatientSignUpPage />} />
                    <Route path="/caregiver/sign-up" element={<CaregiverSignUpPage />} />
                    {/* New self-service magic-link flow */}
                    <Route path="/account/request-link" element={<AccountRequestLinkPage />} />
                    <Route path="/account" element={<AccountUpdatePage />} />
                    <Route path="/account/updated" element={<AccountUpdatedPage />} />
                    <Route path="/account/deleted" element={<AccountDeletedPage />} />
                    {/* Legacy update URLs redirect to the new flow */}
                    <Route path="/patient/update" element={<AccountRequestLinkPage />} />
                    <Route path="/caregiver/update" element={<AccountRequestLinkPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/faq" element={<FAQPage />} />
                    <Route path="/reviews" element={<ReviewsPage />} />
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="/terms" element={<TermsPage />} />
                    <Route path="/cookies" element={<CookiesPage />} />
                    <Route path="/review/:token" element={<ReviewSubmitPage />} />
                  </Routes>
                </main>
                <Footer />
              </>
            }
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
